import React from "react";
import { DrawerContent } from "../../../entities/DrawerContent";

export interface BuilderDrawerState {
    drawerOpen: boolean;
    drawerContent: DrawerContent;
	onMainDrawerChange: (open: boolean, contentType?: DrawerContent) => void;
    showGeniusBadge: boolean;
    dismissGeniusBadge: () => void;
}

export const BuilderDrawerContext = React.createContext<BuilderDrawerState>({} as any);

export function useBuilderDrawer() {
	return React.useContext(BuilderDrawerContext);
}